export default "https://cdn-static.gokick.com/assets/c3e2404f2f1be1cd3bf75e8d7804f871d91db3b2/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";